/**
 * One place for the brand's contact channels, so the footer, the floating
 * social rail and anything added later can't drift apart.
 */
export const WHATSAPP_NUMBER = '447731704144'; // +44 7731 704144
export const WHATSAPP_MESSAGE =
  "Hi Elaichi & Love! I'd like to know more about your chai and wellness offerings.";
export const WHATSAPP_CHAT_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  WHATSAPP_MESSAGE
)}`;

export const INSTAGRAM_HANDLE = 'elaichi_love';
export const INSTAGRAM_URL = `https://instagram.com/${INSTAGRAM_HANDLE}`;

export const WHATSAPP_COMMUNITY_URL = 'https://chat.whatsapp.com/BRpMmd2yYm7KGWFvupUsfG';
export const CONTACT_EMAIL = 'info@elaichilove.com';
